import {useTargetAnnualGoal, useTargetYTDActual} from "../../hooks/kpiHooks";

const KPIValueTargetAnnualDisplay = ({target}) => {
    const annualGoal = useTargetAnnualGoal(target);
    const annualActual = useTargetYTDActual(target);

    return (<div className={`kpi-value-target-display-annual`}>
        <div className="header">{`Annual`}</div>
        <div className="goal">{annualGoal}</div>
        <div className="actual">{annualActual}</div>
    </div> )
}

export default KPIValueTargetAnnualDisplay;